enum GatheringUserVariant {
  Uploader = 'Uploader'
}
export default GatheringUserVariant
